const BASEURL = 'https://pokeapi.co/api/v2/pokemon/'
const TYPEURL = 'https://pokeapi.co/api/v2/type/'
const GENERATIONURL = 'https://pokeapi.co/api/v2/generation/'
const ABILITYURL = 'https://pokeapi.co/api/v2/ability/'
const MOVEURL = 'https://pokeapi.co/api/v2/move/'

interface Pokemon {
  sprites: {
    front_default: string
  }
  name: string
}

interface Solution {
  typeGroup: {
    type: string
    pokemonGroup: Pokemon[]
  }
  generationGroup: {
    generation: string
    pokemonGroup: Pokemon[]
  }
  abilityGroup: {
    ability: string
    pokemonGroup: Pokemon[]
  }
  moveGroup: {
    move: string
    pokemonGroup: Pokemon[]
  }
}

export default async function generateGameData (): Promise<Solution> {
  const typeGroup = await fetchTypeGroup()
  const generationGroup = await fetchGenerationGroup()
  const abilityGroup = await fetchAbilityGroup()
  const moveGroup = await fetchMoveGroup()

  const solution = {
    typeGroup,
    generationGroup,
    abilityGroup,
    moveGroup
  }

  return solution
}

async function fetchTypeGroup (): Promise<{ type: string, pokemonGroup: Pokemon[] }> {
  const pokemonGroup: any[] = []
  const typeIndex = Math.floor(Math.random() * 18) + 1
  const response = await fetch(TYPEURL + typeIndex)
  const data = await response.json()
  const pokemonList = data.pokemon
  const type = data.name

  while (pokemonGroup.length < 4) {
    const randomIndex = Math.floor(Math.random() * pokemonList.length) + 1
    const entryIndex = pokemonList[randomIndex].pokemon.url.split('/')[6]
    const response = await fetch(BASEURL + entryIndex)
    const pokemon = await response.json()

    if (pokemonGroup.length === 0) {
      pokemonGroup.push(pokemon)
    } else if (pokemonGroup.every(p => p.name !== pokemon.name)) {
      pokemonGroup.push(pokemon)
    } else {
      continue
    }
  }

  return { type, pokemonGroup }
}

async function fetchGenerationGroup (): Promise<{ generation: string, pokemonGroup: Pokemon[] }> {
  const pokemonGroup: any[] = []
  const generation = Math.floor(Math.random() * 9) + 1
  const response = await fetch(GENERATIONURL + generation)
  const data = await response.json()
  const pokemonList = data.pokemon_species
  const generationName = data.name

  // get 4 random pokemon from the generation
  while (pokemonGroup.length < 4) {
    try {
      const randomIndex = Math.floor(Math.random() * pokemonList.length) + 1
      const entryIndex = pokemonList[randomIndex].url.split('/')[6]
      const response = await fetch(BASEURL + entryIndex)
      const pokemon = await response.json()

      if (pokemonGroup.length === 0) {
        pokemonGroup.push(pokemon)
      } else if (pokemonGroup.every(p => p.name !== pokemon.name)) {
        pokemonGroup.push(pokemon)
      } else {
        continue
      }
    } catch (error) {
      console.log(error)
    }
  }

  return { generation: generationName, pokemonGroup }
}

async function fetchAbilityGroup (): Promise<{ ability: string, pokemonGroup: Pokemon[] }> {
  const pokemonGroup: any[] = []
  let data = null
  while ((data === null) || data.pokemon.length < 4) {
    try {
      const abilityIndex = Math.floor(Math.random() * 310) + 1
      const response = await fetch(ABILITYURL + abilityIndex)
      data = await response.json()
    } catch (error) {
      console.log(error)
    }
  }
  const pokemonList = data.pokemon
  const ability = data.name

  while (pokemonGroup.length < 4) {
    try {
      const randomIndex = Math.floor(Math.random() * pokemonList.length) + 1
      const entryIndex = pokemonList[randomIndex].pokemon?.url.split('/')[6]
      const response = await fetch(BASEURL + entryIndex)
      const pokemon = await response.json()

      if (pokemonGroup.length === 0) {
        pokemonGroup.push(pokemon)
      } else if (pokemonGroup.every(p => p.name !== pokemon.name)) {
        pokemonGroup.push(pokemon)
      } else {
        continue
      }
    } catch (error) {
      console.log(error)
    }
  }

  return { ability, pokemonGroup }
}

async function fetchMoveGroup (): Promise<{ move: string, pokemonGroup: Pokemon[] }> {
  const pokemonGroup: any[] = []
  // if the move is not learned by at least 4 pokemon, try again
  let data = null
  while ((data === null) || data.learned_by_pokemon.length < 4) {
    try {
      const moveIndex = Math.floor(Math.random() * 919) + 1
      const response = await fetch(MOVEURL + moveIndex)
      data = await response.json()
    } catch (error) {
      console.log(error)
    }
  }
  const pokemonList = data.learned_by_pokemon
  const move = data.name

  while (pokemonGroup.length < 4) {
    try {
      const randomIndex = Math.floor(Math.random() * pokemonList.length) + 1
      const entryIndex = pokemonList[randomIndex].url.split('/')[6]
      const response = await fetch(BASEURL + entryIndex)
      const pokemon = await response.json()

      if (pokemonGroup.length === 0) {
        pokemonGroup.push(pokemon)
      } else if (pokemonGroup.every(p => p.name !== pokemon.name)) {
        pokemonGroup.push(pokemon)
      } else {
        continue
      }
    } catch (error) {
      console.log(error)
    }
  }

  return { move, pokemonGroup }
}
